import BaseValidator from 'services/validations/base-validator';
import {RuleItemInterface} from '../interfaces';
import {isKeyPlayerLineupPositionUsed} from '../helpers';

export default class KeyStatementObjectsNotDuplicatedValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {ruleItem} = this.dependencies;

        if (ruleItem.isStatementTypePlayer()) {
            this.validateKeyPositionNotDuplicated(ruleItem);
        } else if (ruleItem.isStatementTypePosition()) {
            this.validateKeyPlayerNotDuplicated(ruleItem);
        }
    }

    private validateKeyPositionNotDuplicated(ruleItem: RuleItemInterface): void {
        // @ts-ignore
        const {projectionBoostRule, ruleName, sportConfig} = this.dependencies;
        const useKeyPlayerLineupPosition = isKeyPlayerLineupPositionUsed(sportConfig);

        for (const item of projectionBoostRule.getItems()) {
            if (!item.isStatementTypePlayer()) {
                continue;
            }
            if (ruleItem.getKeyPlayer() !== item.getKeyPlayer()) {
                continue;
            }
            if (!useKeyPlayerLineupPosition || item.getKeyPlayerLineupPosition() !== ruleItem.getKeyPlayerLineupPosition()) {
                continue;
            }

            this.addError(`Creation of rules with key Player duplicates is forbidden in ${ruleName}.`);
            return;
        }
    }

    private validateKeyPlayerNotDuplicated(ruleItem: RuleItemInterface): void {
        // @ts-ignore
        const {projectionBoostRule, ruleName, sportConfig} = this.dependencies;
        const useKeyPlayerLineupPosition = isKeyPlayerLineupPositionUsed(sportConfig);

        for (const item of projectionBoostRule.getItems()) {
            if (!item.isStatementTypePosition()) {
                continue;
            }
            if (ruleItem.getKeyPosition() !== item.getKeyPosition()) {
                continue;
            }
            if (!useKeyPlayerLineupPosition || item.getKeyPlayerLineupPosition() !== ruleItem.getKeyPlayerLineupPosition()) {
                continue;
            }

            this.addError(`Creation of rules with key Position duplicates is forbidden in ${ruleName}.`);
            return;
        }
    }
}
